import React from 'react'
import { Link } from 'react-router'

import { tourName, track } from '../../util'
import RegisterLink from '../RegisterLink'
import LiLink from './LiLink'

export default () => [
  <LiLink
    key={0}
    href="/our-solution"
    onClick={() => {
      track({ event: 'welcomeNavClick', label: 'ourSolution' })
    }}
    data-tour={tourName('welcome-navlink-solution')}
  >
    Our Solution
  </LiLink>,

  <LiLink
    key={1}
    href="/contact"
    onClick={() => {
      track({ event: 'welcomeNavClick', label: 'contact' })
    }}
    data-tour={tourName('welcome-navlink-contact')}
  >
    Contact
  </LiLink>,

  <li key={2}>
    <RegisterLink
      className="registerLink"
      onClick={() => {
        track({ event: 'welcomeNavClick', label: 'register' })
      }}
      data-tour={tourName('welcome-navlink-solution-register')}
    >
      Register
    </RegisterLink>
  </li>,

  <li key={3}>
    <Link
      to="/login"
      onClick={() => {
        track({ event: 'welcomeNavClick', label: 'login' })
      }}
      data-tour={tourName('welcome-navlink-login')}
    >
      Log In
    </Link>
  </li>,
]



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/renderWelcomeNav.js